<template>
    <div class="w-full lg:w-2/3 bg-white p-12 h-full">
        <div :class="buttonVisibilityClass" class="flex items-center justify-between pb-20">
            <div v-if="show_back" @click="handleBackClick" class="flex items-center justify-center bg-grey-lighter text-grey-darker text-4xl px-6 py-4 font-bold uppercase rounded-xl">
                <img :src="getIcon('back')" class="icon mr-5" style="width: 1.5rem; height: 1.5rem;">
                <p class="">{{ $t('btn003') }}</p> 
            </div>

            <div v-if="show_logout" @click="toggleModal" class="flex items-center justify-center ml-auto bg-red-lighter text-red-darker text-4xl px-6 py-4 font-bold uppercase rounded-xl">
                <img :src="getIcon('exit')" class="icon mr-5" style="width: 1.5rem; height: 1.5rem;">
                <p class="">{{ $t('btn004') }}</p> 
            </div>

        </div>
        <slot></slot>
    </div>

    <div v-if="!has_rated && this.$store.state.user.hash" class="fixed z-40 papsi-star" @click="toggleRating">
        <img :src="getImage('rate')">
    </div>
    <transition name="slide-in">
        <ModalControl v-if="this.is_modal_open" :is_visible="this.is_modal_open">
            <div v-if="!has_rated" class="flex flex-col justify-center align-center items-center text-center">
                <div class="flex flex-row justify-end align-middle items-end w-full">
                    <IconControl @click="toggleModal" id="exit-black" :width="50" :height="50" />
                </div>
               
                <RatingControl @rating-submitted="handleLogoutSubmitted" @cancel-rating="logout" />
            
            </div>

            <div v-else class="flex flex-col justify-center align-center items-center p-8">
                <img :src="getIcon('logout')" class="mb-10">
                <LabelControl type="dynamic" class="text-grey-darkest font-bold text-5xl mb-8"
                    :content="$t('msg015')" />

                <div class="flex flex-row justify-center align-center items-center mt-5">
                    <ButtonControl :text="$t('btn012')" class="px-8 mr-5" theme="no" @click="toggleModal" />
                    <ButtonControl :text="$t('btn013')" theme="logout" @click="logout" />
                </div>
            </div>
        </ModalControl>
    </transition>

    <transition name="slide-in">
        <ModalControl v-if="this.is_rating_open" :is_visible="this.is_rating_open">
            <div class="flex flex-col justify-center align-center items-center text-center">
                <div class="flex flex-row justify-end align-middle items-end w-full">
                    <IconControl @click="toggleRating" id="exit-black" :width="50" :height="50" />
                </div>
                
                <RatingControl @rating-submitted="handleRatingSubmitted" @cancel-rating="toggleRating" />

            </div>
        </ModalControl>
    </transition>

</template>

<script>
import ButtonControl from '../controls/ButtonControl.vue';
import ModalControl from '../controls/ModalControl.vue';
import LabelControl from '../controls/LabelControl.vue';
import RatingControl from '../controls/RatingControl.vue';
import IconControl from '../controls/IconControl.vue';
import mixin from '@/mixins/controls.js';

export default {
    name: 'v-content',
    mixins: [mixin],
    inject: ['setLoading', 'setError'],
    emits: ['logout'],
    props: {
        show_buttons: {
            type: Boolean,
            default: true,
        },
        show_back: {
            type: Boolean,
            default: true,
        },
        show_logout: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        buttonVisibilityClass() {
            return this.show_buttons ? '' : 'invisible';
        }
    },
    components: {
        ButtonControl,
        ModalControl,
        LabelControl,
        RatingControl,
        IconControl,
    },
    data() {
        return {
            is_modal_open: false,
            is_rating_open: false,
            has_rated: this.$cookies.isKey('has_rated'),
            excluded_pages: [
                'login-page',
                'enter-pin-page',
                'papsi-mobile-login-page',
                'account-serial-numberlogin-page',
                'scan-qr-page'
            ],
            is_excluded_page: false
        };
    },
    watch: {
        // Watch for changes in the route path
        '$route'(to) {
            // Check if the current route is in the excluded_pages array
            this.is_excluded_page = this.excluded_pages.includes(to.name); // You can also use to.path if you prefer
        },
    },
    methods: {
        handleBackClick() {
            this.goBack();
        },
        handleRatingSubmitted() { 
            this.has_rated = true; // Set has_rated to true
            this.$cookies.set('has_rated', true);
            this.is_rating_open = false;  // Close the modal if title is 'Rating'

        },
        handleLogoutSubmitted() {
            this.has_rated = true;
            this.logout();
        },
        logout() {
            this.$emit('logout');
        }
    },

};
</script>

<style scoped>
.papsi-star {
    bottom: 10rem;
    left: 27rem;
    animation: bounce 1s ease-in-out infinite;
    transform-origin: top center;
    width: 8rem;
}

.pulsing {
    display: inline-block;
    /* Ensure the element has a size */
    animation: pulse 1.5s infinite ease-in-out;
    /* Adjust duration as needed */
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(0.9);
        /* Shrink */
    }

    100% {
        transform: scale(1);
        /* Back to original size */
    }
}


@media (min-width: 2500px) {
    .papsi-star {
    bottom: 12rem;
    left: 33rem;
    width: 13rem;
    }

    .icon {
        width: 2rem !important;
        height: 2rem !important;
    }
    .p-12 {
        padding: 5rem !important;
    }
}
</style>